<template>
  <div class="textareaCustom" style="position: relative;">
    <label for="title" class="titleForm">{{label}}</label>
    <div class="textareaBox">
      <v-textarea
        outlined
        dense
        v-model="data"
        :placeholder="placeholder"
        :rules="rules || []"
        :rows="row"
        :row-height="rowHeight"
        hide-details="auto"
        auto-grow
        @change="onchange"
      ></v-textarea>
    </div>
  </div>
</template>
<script>
export default {
  name: "TextAreaCustom",
  components: {},
  props: {
    row: { type: [String, Number], default: 3 },
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    rules: { type: Array },
    rowHeight: { type: [Number, String], default: 15 }
  },
  data() {
    return {
      data: ''
    };
  },
  methods: {
    onchange() {
      this.$emit('input', this.data)
    }
  },
  mounted() {
    this.data = this.value
  }
};
</script>
